import { OrderFormInfoData, Sex } from '@/types/RequisitionFormTypes'
import React from 'react'
import BaseOrderFormInfo from './/BaseOrderFormInfo'

const MOCK_ORDER_FORM_INFO: OrderFormInfoData = {
  patient: {
    id: '12345678',
    name: {
      firstName: 'TestFirstName',
      middleName: '',
      lastName: 'TestLastName',
    },
    mrn: '12345678',
    sex: Sex.Unknown,
    birthDate: new Date(),
  },
  medicalProfessionalInfo: {
    npi: '9876543210',
    name: 'TestDoctorFirst TestDoctorLast',
    email: 'testdoctor@inflectionmedicine.com',
  },
  institution: {
    name: 'TestHospital',
    address: {
      street: '123 Main St',
      city: 'TestCity',
      state: 'MA',
      zip: '12345',
      country: 'USA',
    },
  },
  orderingProvider: {
    name: {
      firstName: 'TestOrderingFirst',
      lastName: 'TestOrderingLast',
    },
    roleTitle: 'MD',
    phone: '1234567890',
    email: 'testordering@inflectionmedicine.com',
  },
}

const MockOrderFormInfo: React.FC = () => {
  return <BaseOrderFormInfo data={MOCK_ORDER_FORM_INFO} />
}

export default MockOrderFormInfo
